import * as moment from "moment/moment.js";

export const readingTime = (content) => {
  if (content) {
    const wpm = 225;
    const words = content.trim().split(/\s+/).length;
    return Math.ceil(words / wpm) || 1;
  } else {
    return 1;
  }
};

export const stripTags = (string) =>
  string ? string.replace(/(<([^>]+)>)/gi, "") : string;

export const getCookie = (cname) => {
  var name = cname + "=";
  var decodedCookie = decodeURIComponent(document.cookie);
  var ca = decodedCookie.split(";");
  for (var i = 0; i < ca.length; i++) {
    var c = ca[i];
    while (c.charAt(0) === " ") {
      c = c.substring(1);
    }
    if (c.indexOf(name) === 0) {
      return c.substring(name.length, c.length);
    }
  }
  return "";
};

export const getLang = () => {
  let wpmlCurrentLanguage = "";

  // Get lang in front
  if (document.getElementsByClassName("frontend").length > 0) {
    wpmlCurrentLanguage =
      document.documentElement.lang.split("-").shift() || "en";
  }
  // Get lang in back office
  else {
    wpmlCurrentLanguage = getCookie("wp-wpml_current_language") || "en";
  }

  return wpmlCurrentLanguage;
};

export const displayFormat = () =>
  moment.locale() === "en-gb" ? "MMMM Do YYYY" : "LL";

export const getHomeUrl = (addEndPath = "") => {
  const pathElement = window.location.pathname.split("/");
  let lang = "";
  if (pathElement.length > 2) lang = pathElement[1];
  const endPath = addEndPath ? `/${addEndPath}` : "";
  return `/${lang}${endPath}`;
};

export const getSeasonColor = () => {
  return getComputedStyle(document.documentElement).getPropertyValue(
    "--seasonColorRoot"
  );
};

export const getSeasonColorHover = () => {
  return getComputedStyle(document.documentElement).getPropertyValue(
    "--seasonColorHoverRoot"
  );
};

export const ignoreOrderCompare = (a, b) => {
  if (a.length !== b.length) return false;
  const elements = new Set([...a, ...b]);
  for (const x of elements) {
    const count1 = a.filter((e) => e === x).length;
    const count2 = b.filter((e) => e === x).length;
    if (count1 !== count2) return false;
  }
  return true;
};

export const quartile = (data, q) => {
  data = data.sort((a, b) => a - b);
  let pos = (data.length - 1) * q;
  let base = Math.floor(pos);
  let rest = pos - base;
  if (data[base + 1] !== undefined) {
    return data[base] + rest * (data[base + 1] - data[base]);
  } else {
    return data[base];
  }
};

export const traducButton = (t, key) => {
  let countryCode = "";
  let traductKey = key;

  // Get country code from HTML
  const element = document.getElementById("country-code");
  if (element && "country-code" in element.dataset) {
    countryCode = element.dataset.countryCode;
    traductKey += " " + countryCode;
  }

  // Adapt button translations according to the country
  switch (countryCode) {
    case "BE":
      return t(traductKey);
    default:
      return t(key);
  }
};

export const adjustColor = (hex, percentage, light = false) => {
  const r = parseInt(hex.slice(1, 3), 16);
  const g = parseInt(hex.slice(3, 5), 16);
  const b = parseInt(hex.slice(5, 7), 16);

  let newR, newG, newB;

  if (light) {
    newR = Math.min(255, r + (255 - r) * percentage);
    newG = Math.min(255, g + (255 - g) * percentage);
    newB = Math.min(255, b + (255 - b) * percentage);
  } else {
    newR = Math.max(0, r - r * percentage);
    newG = Math.max(0, g - g * percentage);
    newB = Math.max(0, b - b * percentage);
  }

  // Function to convert a number to a two-digit hexadecimal string
  const toHex = (value) => {
    const hex = Math.round(value).toString(16);
    return hex.length === 1 ? `0${hex}` : hex;
  };

  const newColorHex = `#${toHex(newR)}${toHex(newG)}${toHex(newB)}`;
  return newColorHex;
};

// Attributes of a child block on the front. js-block-engine 3.1.0 renders each child as a node
// (props.node.componentProps), where 2.2.1 passed the attributes as the child's own props.
export const getChildBlockProps = (child) =>
  child?.props?.node?.componentProps ?? child?.props ?? {};
